<template>
  <label>{{ products.length }} produits favoris</label>
  <div class="product-list row mb-4 d-flex flex-wrap align-items-stretch g-3">
    <ProductCardFavorite
      v-for="product in products"
      :key="product.id"
      :product="product"
    />
  </div>
</template>

<script>
  import ProductCardFavorite from "./ProductCardFavorite.vue";

  export default {
    name: "ProductList",
    components: {
      ProductCardFavorite,
    },
    props: {
      products: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {};
    },
    methods: {},
  };
</script>
